// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1yMqy","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3QyFT"};